import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest } from '@angular/common/http';

import * as InventoryModels from '../../models/inventory/inventory';
import * as DepositeModels from '../../models/deposite/deposite';
import * as Models from '../../models/commonModels';
import { EnvironmentService } from '../../../app/services/environment.service';


@Injectable({
  providedIn: 'root'
})
export class InventoryService {

  constructor(private httpClient: HttpClient,
    private environmentService: EnvironmentService) { }

  public getList(Search: InventoryModels.InventorySearchModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    Search.RequestSignature = Math.random();

    return this.httpClient.post<Models.ResponseList<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/list`, Search, options);
  }

  public get(Inventory: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/get`, Inventory, options);
  }

  public getCurrent() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<Models.Response<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/get-current`);
  }

  public getClosest() {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.get<Models.Response<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/get-closest`);
  }

  public set(Inventory: Models.Request<InventoryModels.InventoryModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/set`, Inventory, options);
  }

  public delete(Inventory: Models.Request<InventoryModels.InventoryModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/delete`, Inventory, options);
  }

  public setManual(Inventory: Models.Request<InventoryModels.InventoryModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    const options = { headers: httpHeaders };

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("InventoryId", Inventory.Item.InventoryId.toString());
    formData.append("RequestSignature", Inventory.RequestSignature.toString());

    return this.httpClient.post<Models.Response<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/set-manual`, formData);
  }

  public getManual(Inventory: Models.Request<InventoryModels.InventoryModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders, responseType: 'blob' as 'json' };
    return this.httpClient.post<any>(`${this.environmentService.getApiURL()}/inventory/get-manual`, Inventory, { headers: httpHeaders, responseType: 'blob' as 'json', observe: 'response' });
  }

  public upladSummary(File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);

    return this.httpClient.post<Models.Response<InventoryModels.InventoryModel>>(`${this.environmentService.getApiURL()}/inventory/uplad-summary`, formData);
  }

  public setSummary(Inventory: Models.Request<InventoryModels.InventoryGarageModel>, File: File) {

    const httpHeaders = new HttpHeaders()
      .set("Content-Type", "multipart/form-data")
      .set("Accept", "application/json");

    const options = { headers: httpHeaders };

    var formData: FormData = new FormData();

    formData.append("UploadFile", File, File.name);
    formData.append("Inventory_GarageId", Inventory.Item.Inventory_GarageId.toString());
    formData.append("RequestSignature", Inventory.RequestSignature.toString());

    return this.httpClient.post<Models.Response<InventoryModels.InventoryGarageModel>>(`${this.environmentService.getApiURL()}/inventory/set-summary-document`, formData);
  }

  public getDepositeInventories(Deposite: Models.Request<DepositeModels.DepositeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.ResponseList<InventoryModels.InventoryDepositeModel>>(`${this.environmentService.getApiURL()}/inventory/get-deposite-inventories`, Deposite, options);
  }

  public getDepositeInventoryChanges(InventoryDeposit: Models.Request<InventoryModels.InventoryDepositeModel>) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<InventoryModels.InventoryDepositeChanges>>(`${this.environmentService.getApiURL()}/inventory/get-deposite-inventory-changes`, InventoryDeposit, options);
  }

  public chargeForExtraSeason(Request: Models.RequestBase) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<number>>(`${this.environmentService.getApiURL()}/inventory/charge-for-extra-season`, Request, options);
  }
}


